import { useIsLaptop } from '#src/hooks/device/useIsLaptop.ts';

/**
 * Picks the half of a `_MOBILE` / `_DESKTOP` branding pair that matches the
 * viewport. Either half stands in for a missing sibling, so a set that filled
 * only one of the two keeps rendering it at every width.
 */
export const useResponsiveBrandingUrl = () => {
  const isLaptopAndAbove = useIsLaptop();

  return (mobile: Nullable<string>, desktop: Nullable<string>) =>
    isLaptopAndAbove ? (desktop ?? mobile) : (mobile ?? desktop);
};
